export default __webpack_public_path__ + "static/media/90.0d5dd271.png";